<template>
  <div class="leave-stat">
    <!-- 请假统计（企业微信手机端）：按年月统计每个职员的请假天数，点击查看对应请假单 -->
    <mobile-list-header>
      <!-- 搜索框沿用列表页样式；本页不支持关键字，搜索即刷新当前统计 -->
      <div class="search-bar">
        <div class="search-input">
          <yq-icon class="icon" name="element-ui_search"/>
          <input disabled placeholder="暂不支持关键字查询"/>
        </div>
        <div class="search-btn" @click="loadReport">搜索</div>
      </div>
      <div class="filter-row">
        <mobile-month-select v-model="month" placeholder="统计月份" label="统计月份" title="选择统计月份"
                             @change="loadReport"/>
        <span class="tip-text">只统计已通过的请假单，点击查看该职员当月请假单</span>
      </div>
    </mobile-list-header>

    <div class="stat-body" v-loading="loading">
      <list-card class="person-item" v-for="item in peopleRows" :key="item.dimKey"
                 :label="item.dimTitle || item.dimKey" @click="toLeaveApply(item)">
        <template #desc>
          <span class="count-text">{{ item.applyCount || 0 }} 单</span>
          <yq-icon class="item-arrow" name="element-ui_arrow-right"/>
        </template>
        <data-column label="请假天数">
          <span class="days-text">{{ days(item.totalDays) }} 天</span>
        </data-column>
        <data-column label="单均天数">{{ days(item.avgDays) }} 天</data-column>
      </list-card>
      <div v-if="!loading && peopleRows.length === 0" class="empty">当月暂无已通过的请假单</div>
    </div>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import MobileListHeader from "@/components/qywx/layout/MobileListHeader.vue";
import MobileMonthSelect from "@/components/qywx/data/MobileMonthSelect.vue";
import ListCard from "@/components/qywx/layout/ListCard.vue";
import DataColumn from "@/components/qywx/data/DataColumn.vue";
import YqIcon from "@/components/YqIcon.vue";
import leaveStatApi from "@/api/dz-crm/leave/leaveStatApi";

/** 当前月 yyyy-MM */
function currentMonth() {
  const now = new Date();
  return now.getFullYear() + "-" + String(now.getMonth() + 1).padStart(2, "0");
}

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "LeaveStatQW",
  components: {
    YqIcon, DataColumn, ListCard, MobileMonthSelect, MobileListHeader
  },
  data() {
    return {
      loading: false,
      month: currentMonth(),
      report: {},
    };
  },
  computed: {
    peopleRows() {
      return this.report.peopleRows || [];
    }
  },
  created() {
    this.loadReport();
  },
  methods: {
    loadReport() {
      if (!this.month) {
        return;
      }
      this.loading = true;
      leaveStatApi.report({monthLabel: this.month}).then(res => {
        this.report = res || {};
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      })
    },
    /** 月份换算成起止日期，带到请假申请页做同样的时间过滤 */
    monthRange() {
      const parts = String(this.month).split("-");
      const year = Number(parts[0]);
      const month = Number(parts[1]);
      const lastDay = new Date(year, month, 0).getDate();
      return {
        start: `${this.month}-01`,
        end: `${this.month}-${String(lastDay).padStart(2, "0")}`,
      };
    },
    toLeaveApply(item) {
      const range = this.monthRange();
      this.router.push({
        path: "/qywx/crm/leave-apply",
        query: {
          applicantId: item.dimKey,
          applicantName: item.dimTitle || "",
          startDateFrom: range.start,
          startDateTo: range.end,
        },
      });
    },
    days(value) {
      if (value === null || value === undefined || value === "") {
        return "0";
      }
      return String(Number(value));
    }
  }
};
</script>

<style lang="scss" scoped>
.leave-stat{
  height: 100%;
  display: flex;
  flex-direction: column;
}
.search-bar{
  display: flex;
  align-items: center;
  height: 44px;
  padding-left: 12px;
  border-radius: 999px;
  background: var(--yq-background-color);
  overflow: hidden;
  .search-input{
    flex: 1;
    display: flex;
    align-items: center;
    min-width: 0;
    height: 100%;
    padding-right: 12px;
    .icon{
      flex: none;
      color: var(--yq-font-color-desc);
      font-size: var(--yq-font-size-mini-mobile);
    }
    input{
      flex: 1;
      min-width: 0;
      height: 100%;
      margin-left: 6px;
      border: none;
      outline: none;
      background: transparent;
      font-size: var(--yq-font-size-mini-mobile);
      color: var(--yq-font-color-desc);
      -webkit-text-fill-color: var(--yq-font-color-desc);
      opacity: 1;
      &::placeholder{
        color: var(--yq-font-color-desc);
      }
    }
  }
  .search-btn{
    flex: none;
    display: flex;
    align-items: center;
    height: 100%;
    padding: 0 18px;
    background: var(--el-color-primary);
    color: #FFF;
    font-size: var(--yq-font-size-mini-mobile);
  }
}
.filter-row{
  display: flex;
  align-items: center;
  gap: 18px;
  margin-top: 10px;
  overflow-x: auto;
  scrollbar-width: none;
  &::-webkit-scrollbar{
    display: none;
  }
  > *{
    flex: none;
  }
  .tip-text{
    font-size: var(--yq-font-size-mini-mobile);
    color: var(--yq-font-color-desc);
  }
}
// 「点击查看…」提示：位于查询条件下方、左右居中
.click-hint{
  margin-top: 8px;
  text-align: center;
  font-size: var(--yq-font-size-mini-mobile);
  color: var(--yq-font-color-desc);
}
.stat-body{
  flex: 1;
  overflow-y: auto;
  padding: 10px;
  box-sizing: border-box;
}
.person-item{
  :deep(.card-title .desc){
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .count-text{
    color: var(--yq-font-color-desc);
  }
  .days-text{
    font-weight: 600;
    color: var(--el-color-primary);
    font-variant-numeric: tabular-nums;
  }
  .item-arrow{
    color: var(--yq-font-color-desc);
    font-size: var(--yq-font-size-mini-mobile);
  }
}
.empty{
  padding: 30px 0;
  text-align: center;
  font-size: var(--yq-font-size-mini-mobile);
  color: var(--yq-font-color-desc);
}
</style>
